import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const ExperienceDepressionContext = React.createContext();

export const useExperienceDepressionContext = () => useContext(ExperienceDepressionContext);

export function ExperienceDepressionProvider({ children }) {
  const [recommendedExperiences, setRecommendedExperiences] = useState([]);
  const [recommendedExperiencesSecond, setRecommendedExperiencesSecond] = useState([]);
  const [recommendedHeading, setRecommendedHeading] = useState({});
  const [infoContent, setInfoContent] = useState({});
  const [infoContentSecond, setInfoContentSecond] = useState({});
  const [suggestedQuestions, setSuggestedQuestions] = useState({});
  const [iframeData, setIframeData] = useState({});
  const [iframeDataSecond, setIframeDataSecond] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/f93d9de5-6612-4913-a9aa-65fda177d5c3')
      .then(setRecommendedExperiences);
    fetchData
      .get('https://run.mocky.io/v3/4e782ba6-9387-42f8-a820-b3bee1e37c28')
      .then(setRecommendedExperiencesSecond);
    fetchData
      .get('https://run.mocky.io/v3/ddf670d8-e7aa-4224-a0a1-0012c54d8d0c')
      .then(setRecommendedHeading);
    fetchData
      .get('https://run.mocky.io/v3/5309a6bf-794a-4258-9d20-faa3f268abd3')
      .then(setSuggestedQuestions);
    fetchData
      .get('https://run.mocky.io/v3/dc408cc8-ed01-420d-a99c-35d571c9a53e')
      .then(setInfoContent);
    fetchData
      .get('https://run.mocky.io/v3/394b9d14-4405-467f-b9f1-1fd8ce440c4b')
      .then(setInfoContentSecond);
    fetchData
      .get('https://run.mocky.io/v3/8e6d47d3-89cb-4164-8553-12ba387fd68a')
      .then(setIframeData);
    fetchData
      .get('https://run.mocky.io/v3/fb81d034-3ced-4241-8892-1538797068c5')
      .then(setIframeDataSecond);
  }, []);

  const value = useMemo(
    () => ({
      recommendedExperiences,
      recommendedHeading,
      infoContent,
      suggestedQuestions,
      iframeData,
      infoContentSecond,
      iframeDataSecond,
      recommendedExperiencesSecond,
    }),
    [
      recommendedExperiences,
      recommendedHeading,
      infoContent,
      suggestedQuestions,
      iframeData,
      infoContentSecond,
      iframeDataSecond,
      recommendedExperiencesSecond,
    ]
  );

  return (
    <ExperienceDepressionContext.Provider value={value}>
      {children}
    </ExperienceDepressionContext.Provider>
  );
}
